import React, { useEffect, useState } from "react";
import ProfileRow from "./ProfileRow";
import WidgetFooter from "./WidgetFooter";
import WidgetBoxSmall from "./WidgetBoxSmall";
import WidgetColorAdjustmentBoxLarge from "./WidgetColorAdjustmentBoxLarge";
import WidgetContentAdjustmentBoxLarge from "./WidgetContentAdjustmentBoxLarge";
import WidgetOrientationAdjustmentBoxLarge from "./WidgetOrientationAdjustmentBoxLarge";
import useColorAdjustment from "../Hooks/colorAdjustment/useColorAdjustment";
import useMultiFeatures from "../Hooks/multiFeatures/useMultiFeatures";
import useContentAdjustment from "../Hooks/contentAdjustment/useContentAdjustment";
import useOrientationAdjustment from "../Hooks/orientationAdjustment/useOrientationAdjustment";
import useProfileAdjustment from "../Hooks/profileAdjustment/useProfileAdjustment";
import ResetIcon from "./images/ResetIcon";
import HideInterFaceIcon from "./images/HideInterFaceIcon";
import ZoomOutSmIcon from "./images/ZoomOutSmIcon";
import FontIcon from "./images/FontIcon";
import PaperIcon from "./images/PaperIcon";
import MarkerIcon from "./images/MarkerIcon";
import ZoomIcon from "./images/ZoomIcon";
import CenterIcon from "./images/CenterIcon";
import LeftIcon from "./images/LeftIcon";
import RightIcon from "./images/RightIcon";
import RightModeIcon from "./images/RightModeIcon";
import LightModeIcon from "./images/LightModeIcon";
import DarkModeIcon from "./images/DarkModeIcon";
import InkIcon from "./images/InkIcon";
import DropOfLiquidIcon from "./images/DropOfLiquidIcon";
import DropSilhouetteIcon from "./images/DropSilhouetteIcon";
import MuteIcon from "./images/MuteIcon";
import ImageIcon from "./images/ImageIcon";
import ReadingModeIcon from "./images/ReadingModeIcon";
import ReadingGuideIcon from "./images/ReadingGuideIcon";
import StopAnimationIcon from "./images/StopAnimationIcon";
import ReadingMaskIcon from "./images/ReadingMaskIcon";
import HighlightHoverIcon from "./images/HighlightHoverIcon";
import HighlightFocusIcon from "./images/HighlightFocusIcon";
import BlackCurserIcon from "./images/BlackCurserIcon";
import WhiteCurserIcon from "./images/WhiteCurserIcon";
import PositionsLeftRight from "./images/PositionsLeftRight";
import {
  ALL_ELEMENTS,
  ELEMENTS,
  MATCH_COLOR,
  PARAMETER_EVENT,
  WIDGET_CLASS_ATTRIBUTES,
} from "../utils/constants";
import { activeIcon } from "../utils";

const WidgetPopup = ({ toggleState, togglePsotion, setState }) => {
  const {
    darkContrast,
    lightContrast,
    highContrast,
    highSaturation,
    lowSaturation,
    monoChromeSaturation,
    handleTextColor,
    setColorAdjutment,
    colorAdjutment,
    setColorTitleAdjustment,
    handletitleColor,
    handleBackgrondColor,
    setBackgroundColorAdjustment,
    colorTitleAdjustment,
  } = useColorAdjustment();
  const {
    readableFont,
    highLightTile,
    HighlightLinks,
    textAlignCenter,
    textAlignLeft,
    textAlignRight,
    textMagnifier,
    setZoom,
    zoom,
    contentScaling,
    fontsize,
    setFontsize,
    handleFontSize,
    lineHeight,
    setLineHeight,
    handleLineHeight,
    handleLetterSpacing,
    letterSpacing,
    setLetterSpacing,
  } = useContentAdjustment();
  const {
    SeizureSafeProfile,
    visionImpairedProfile,
    adhdFriendlyProfile,
    cognitiveDisabilityProfile,
    blindUserScreenReader,
    screenReaderToggle,
    overSizeWidget,
    dyslexicFont,
    keyboardNavigation,
  } = useProfileAdjustment();
  const {
    resetSetting,
    hideInterFace,
    hideInterFaceNone,
    handleAnchorButton,
    getDuplicateHrefs,
    handleIframeOrFrameElements,
    handleStuctureIssues,
    handleInputTextareaElements,
    handleEmptyIds,
    handleCustomButtons,
    checkForDuplicateIDs,
    checkHeadingSequence,
    handleImageAlt,
  } = useMultiFeatures();
  const {
    cursorWhite,
    cursorBlack,
    highLightFocus,
    highlightHover,
    hideImages,
    UseFulLinks,
    readingGuide,
    readingMask,
    muteSound,
    animationsStop,
    readMode,
  } = useOrientationAdjustment();

  const pathName = window.location.pathname;

  const [eventTriggered, setEventTriggered] = useState(0);

  // Select the node that will be observed for mutations
  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  const callback = function (mutationsList, observer) {
    setEventTriggered((prev) => prev + 1);
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  // ADD EMBED WIDGET GLOBAL
  useEffect(() => {
    const handleClick = () => {
      setEventTriggered((prev) => prev + 1);
    };

    //  SET CUSTOM ATTRIBUTE FOR READ MODE FEATURES AND ADD MAIN CONTAINER  //

    // let altAttributes = {};

    const elements = document.querySelectorAll(ALL_ELEMENTS);
    for (let i = 0; i < elements.length; i++) {
      // ============= GET ALL INLINE STYLE AND STORE SEPRATE ATRIBUTE =============== //

      let getPrevStyle = elements[i].getAttribute("style");
      let isExist = elements[i].getAttribute(
        WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_STYLE
      );
      if (!isExist && getPrevStyle !== null) {
        if (getPrevStyle.includes("color")) {
          for (let j = 0; j < MATCH_COLOR.length; j++) {
            if (getPrevStyle.includes(MATCH_COLOR[j])) {
              getPrevStyle = getPrevStyle
                .replace(/color:\s*[^;]*;?\s*!important;/g, "")
                .trim();
            }
          }
        }
        if (getPrevStyle) {
          elements[i].setAttribute(
            WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_STYLE,
            getPrevStyle
          );
        }
      }

      // ============= FONT SIZE GET AND STORE =============== //

      const fontSizeVal = window.getComputedStyle(elements[i]).fontSize;
      let getAttri = elements[i].getAttribute(
        WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_FONTSIZE
      );
      if (!getAttri && fontSizeVal !== "0px") {
        elements[i].setAttribute(
          WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_FONTSIZE,
          fontSizeVal
        );
      }

      // ============= HANLE GLOBAL ACCESIBILITY CODE ISSUES =============== //

      // ============= HANDLE ANCHOR AND BUTTON =============== //
      handleAnchorButton(elements[i]);
      // ============= HANDLE INPUT & TEXTAREA =============== //
      handleInputTextareaElements(elements[i]);
      // ============= HANDLE IMAGE =============== //
      handleImageAlt(elements[i]);
      // ============= HANDLE IFRAME & FRAME =============== //
      handleIframeOrFrameElements(elements[i]);
      // ============= HANDLE CUSTOM BUTTON =============== //
      handleCustomButtons(elements[i]);
      // ============= HANDLE EMPTY ID =============== //
      handleEmptyIds(elements[i]);
      // ============= HANDLE STRUCTURE ISSUES =============== //
      handleStuctureIssues(elements[i]);
    }

    // FontSize //
    let sizeFont = parseFloat(localStorage.getItem("rcp-font-size"));
    if (sizeFont) {
      handleFontSize(PARAMETER_EVENT.ONLOAD);
    }

    //  TEXT AND TITLE COLOR  //
    let myColorState = JSON.parse(localStorage.getItem("rcpColorState"));
    setColorAdjutment(
      myColorState?.color?.length > 0
        ? myColorState
        : { color: "", rgbaColor: "", isActive: true }
    );

    let persisttitleColor = JSON.parse(
      localStorage.getItem("rcpTitleColorState")
    );
    setColorTitleAdjustment(
      persisttitleColor?.rcpTitleColor?.length > 0
        ? persisttitleColor
        : { rcpTitleColor: "", rgbaColor: "", isActivetitleColor: true }
    );

    //  STOP ANIMATIONS  //
    let stopAnimation = localStorage.getItem("rcp-animations-stop");
    if (stopAnimation) {
      animationsStop(PARAMETER_EVENT.ONLOAD);
    }

    // KEYBOARD NAVIGATION //
    let keyNavigation = localStorage.getItem("rcp-keyboard-navigation");
    if (keyNavigation) {
      keyboardNavigation(PARAMETER_EVENT.ONLOAD);
    }

    // ============= HANDLE DUPLICATE ID's =============== //
    checkForDuplicateIDs();
    // ============= HANDLE DUPLICATE HREF WITH DIFERENT ARIA_LABELS =============== //
    getDuplicateHrefs("a");
    // ============= HANDLE HEADING STRUCTURE SEQUENCE =============== //
    checkHeadingSequence();

    document.body.addEventListener("click", handleClick);

    // Clean up function to remove the event listener
    return () => {
      document.body.removeEventListener("click", handleClick);
    };
  }, [eventTriggered]);

  useEffect(() => {
    let body = document.getElementsByTagName("body")[0];

    //  Handle Focusable Button To Direct Open Accessibility Widget Tool  //
    let focusParent = document.createElement("div");

    let openWidgetBtn = document.createElement("button");
    openWidgetBtn.innerText = "Open the Accessibility Menu";
    openWidgetBtn.className += "accessibilityWidgetFocusableBtn";

    let skipToMainContent = document.createElement("a");
    skipToMainContent.href = "#Skip";
    skipToMainContent.innerText = "Skip To Main Content";
    skipToMainContent.className += "accessibilityWidgetFocusableBtn";

    let enableAccessibilityForLowVisionBtn = document.createElement("button");
    enableAccessibilityForLowVisionBtn.innerText =
      "Enable Accessibility for low vision";
    enableAccessibilityForLowVisionBtn.className +=
      "accessibilityWidgetFocusableBtn";

    let focusOpenWidgetBtn = document.querySelector(
      ".accessibilityWidgetFocusableBtn"
    );
    if (!focusOpenWidgetBtn) {
      focusParent.append(openWidgetBtn);
      focusParent.append(skipToMainContent);
      focusParent.append(enableAccessibilityForLowVisionBtn);
      body.insertBefore(focusParent, body.firstChild);
    }
    openWidgetBtn?.addEventListener("click", () => {
      setState(PARAMETER_EVENT.OPEN);
      let widgetCloseBtn = document.querySelector(".widgetPopUpCloseBtn");
      if (widgetCloseBtn) {
        widgetCloseBtn.focus();
        openWidgetBtn.style.opacity = 0;
      }
    });
    enableAccessibilityForLowVisionBtn?.addEventListener("click", () => {
      cursorWhite(PARAMETER_EVENT.TOGGLE);
      readableFont(PARAMETER_EVENT.TOGGLE);
      HighlightLinks(PARAMETER_EVENT.TOGGLE);
      dyslexicFont(PARAMETER_EVENT.TOGGLE);
      animationsStop(PARAMETER_EVENT.TOGGLE);
      highLightFocus(PARAMETER_EVENT.TOGGLE);
      textMagnifier(PARAMETER_EVENT.TOGGLE);
      enableAccessibilityForLowVisionBtn.blur();
    });

    // ============= CHECK LOCAL AFTER RELOAD STYE =============== //

    //  COLOR ADJUSTMENT  //
    let contrastDark = localStorage.getItem("rcp-dark-contrast");
    if (contrastDark) {
      darkContrast(PARAMETER_EVENT.ONLOAD);
    }

    let contrastLight = localStorage.getItem("rcp-light-contrast");
    if (contrastLight) {
      lightContrast(PARAMETER_EVENT.ONLOAD);
    }

    let contrastHigh = localStorage.getItem("rcp-high-contrast");
    if (contrastHigh) {
      highContrast(PARAMETER_EVENT.ONLOAD);
    }

    let saturationHigh = localStorage.getItem("rcp-high-saturation");
    if (saturationHigh) {
      highSaturation(PARAMETER_EVENT.ONLOAD);
    }

    let saturationLow = localStorage.getItem("rcp-low-saturation");
    if (saturationLow) {
      lowSaturation(PARAMETER_EVENT.ONLOAD);
    }

    let saturationMonoChrome = localStorage.getItem(
      "rcp-monoChrome-saturation"
    );
    if (saturationMonoChrome) {
      monoChromeSaturation(PARAMETER_EVENT.ONLOAD);
    }

    let myPersistBackgroundColor = JSON.parse(
      localStorage.getItem("rcpBgColorState")
    );
    setBackgroundColorAdjustment(
      myPersistBackgroundColor?.rcpBgColor?.length > 0
        ? myPersistBackgroundColor
        : { rcpBgColor: "", rgbaColor: "", isActiveBackgroundColor: true }
    );

    //  CONTENT ADJUSTMENT  //
    let fontReadable = localStorage.getItem("rcp-readable-font");
    if (fontReadable) {
      readableFont(PARAMETER_EVENT.ONLOAD);
    }

    let titlesLightHigh = localStorage.getItem("rcp-highlight-tile");
    if (titlesLightHigh) {
      highLightTile(PARAMETER_EVENT.ONLOAD);
    }

    let linksLightHight = localStorage.getItem("rcp-highlight-links");
    if (linksLightHight) {
      HighlightLinks(PARAMETER_EVENT.ONLOAD);
    }

    let centerAlignText = localStorage.getItem("rcp-text-align-center");
    if (centerAlignText) {
      textAlignCenter(PARAMETER_EVENT.ONLOAD);
    }

    let leftAlignText = localStorage.getItem("rcp-textalign-left");
    if (leftAlignText) {
      textAlignLeft(PARAMETER_EVENT.ONLOAD);
    }

    let rightAlignText = localStorage.getItem("rcp-textalign-right");
    if (rightAlignText) {
      textAlignRight(PARAMETER_EVENT.ONLOAD);
    }

    let magnifierText = localStorage.getItem("rcp-text-magnifier");
    if (magnifierText) {
      textMagnifier(PARAMETER_EVENT.ONLOAD);
    }

    let scalingContent = parseFloat(
      localStorage.getItem("rcp-content-scaling")
    );
    if (scalingContent) {
      setZoom(scalingContent);
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    let heightLine = localStorage.getItem("rcp-line-height");
    if (heightLine) {
      let storedValue = parseFloat(heightLine);
      setLineHeight(storedValue);
      body.classList.add("rcpLineHeight");
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    let spacingLetter = localStorage.getItem("rcp-letter-spacing");
    if (spacingLetter) {
      let storedValue = parseFloat(spacingLetter);
      setLetterSpacing(storedValue);
      body.classList.add("rcpLetterSpacing");
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    //  ORIENTATION ADJUSTMENT  //
    let whiteCursor = localStorage.getItem("rcp-white-cursor");
    if (whiteCursor) {
      cursorWhite(PARAMETER_EVENT.ONLOAD);
    }

    let blackCursor = localStorage.getItem("rcp-black-cursor");
    if (blackCursor) {
      cursorBlack(PARAMETER_EVENT.ONLOAD);
    }

    let focusHightLight = localStorage.getItem("rcp-highLight-focus");
    if (focusHightLight) {
      highLightFocus(PARAMETER_EVENT.ONLOAD);
    }

    let hoverHighlight = localStorage.getItem("rcp-highlight-hover");
    if (hoverHighlight) {
      highlightHover(PARAMETER_EVENT.ONLOAD);
    }

    let imageHide = localStorage.getItem("rcp-hide-image");
    if (imageHide) {
      hideImages(PARAMETER_EVENT.ONLOAD);
    }

    let guideReading = localStorage.getItem("rcp-reading-guide-curser");
    if (guideReading) {
      readingGuide(PARAMETER_EVENT.ONLOAD);
    }

    let maskReading = localStorage.getItem("rcp-reading-mask");
    if (maskReading) {
      readingMask(PARAMETER_EVENT.ONLOAD);
    }

    let soundMuted = localStorage.getItem("rcp-mute-sound");
    if (soundMuted) {
      muteSound(PARAMETER_EVENT.ONLOAD);
    }

    let modeRead = localStorage.getItem("rcp-read-mode");
    if (modeRead) {
      readMode(PARAMETER_EVENT.ONLOAD);
    }

    //  PROFILE ADJUSTMENT  //
    let profileSafeSeizure = localStorage.getItem("rcp-seizure-safe-profile");
    if (profileSafeSeizure) {
      SeizureSafeProfile(PARAMETER_EVENT.ONLOAD);
    }

    let profileImpairedVision = localStorage.getItem(
      "rcp-vision-impaired-profile"
    );
    if (profileImpairedVision) {
      visionImpairedProfile(PARAMETER_EVENT.ONLOAD);
    }

    let profilefriendlyAdHd = localStorage.getItem("rcp-adhd-friendly-profile");
    if (profilefriendlyAdHd) {
      adhdFriendlyProfile(PARAMETER_EVENT.ONLOAD);
    }

    let profileDisabilityCognitive = localStorage.getItem(
      "rcp-cognitive-disability-profile"
    );
    if (profileDisabilityCognitive) {
      cognitiveDisabilityProfile(PARAMETER_EVENT.ONLOAD);
    }

    let readerScreen = localStorage.getItem("rcp-blind-user-screen-reader");
    if (readerScreen) {
      blindUserScreenReader(PARAMETER_EVENT.ONLOAD);
    }

    let sizeOverWidget = localStorage.getItem("rcp-over-size-widget");
    if (sizeOverWidget) {
      overSizeWidget(PARAMETER_EVENT.ONLOAD);
    }

    let fontDyslexic = localStorage.getItem("rcp-dylexic-font");
    if (fontDyslexic) {
      dyslexicFont(PARAMETER_EVENT.ONLOAD);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenReaderToggle, pathName]);

  return (
    <section id="WidgetPopUpContainer">
      <div id="hideInterFacePopUp">
        <div className="hideInterFacePopUpContent">
          <button
            onClick={hideInterFace}
            className="hideInterFacePopUp-close-btn"
            aria-label="Press enter to Close the accessibility"
          ></button>
          <h1 aria-label="Hide Accessibility Interface" role="region">
            Hide Accessibility Interface?
          </h1>
          <p className="" aria-label="note: for hide accessibility interface">
            Please note: If you choose to hide the accessibility interface, you
            won't be able to see it anymore, unless you clear your browsing
            history and data. Are you sure that you wish to hide the interface?
          </p>
          <div className="hideInterFacePopUpBtnContainer">
            <button tabIndex={0} onClick={hideInterFaceNone}>
              Accept
            </button>
            <button tabIndex={0} onClick={hideInterFace}>
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div id="WidgetPopUpHeader">
        <button
          className="widgetPopUpCloseBtn"
          onClick={() => toggleState()}
          aria-label="Press enter to Close the accessibility menu"
        >
          <span className="focus-outline"></span>
        </button>
        <div className="WidgetPopUpHeaderContent">
          <h1
            id="headerHeading"
            role="region"
            aria-label="heading: Accessibility Adjustment"
          >
            Accessibility Adjustments
          </h1>
          <div className="WidgetPopUpBtnContainer">
            <button
              role="region"
              onClick={resetSetting}
              aria-label="reset seting"
              id="WidgetPopUpBtnReset"
            >
              <ResetIcon />
              Reset Settings
            </button>
            <button
              role="region"
              aria-label="hide interface"
              id="WidgetPopUpBtnHideInterFace"
              onClick={hideInterFace}
            >
              <HideInterFaceIcon />
              Hide Interface
            </button>
            <button
              role="region"
              aria-label="Left Right Positions"
              id="WidgetPopUpBtnPositions"
              className="respBoxNone"
              onClick={() => togglePsotion()}
            >
              <PositionsLeftRight />
              Positions
            </button>
          </div>
        </div>
      </div>
      <div
        className="WidgetPopUpCardContainer"
        style={{ position: "relative", bottom: "15px" }}
      >
        <div id="WidgetAccessibilityProfileContent">
          <h2
            className="WidgetPopupHeading"
            role="region"
            aria-label="Accessibility Profile"
          >
            Profile Accessibility
          </h2>
          <div className="WidgetAjustmentBoxContainer">
            <div
              className="responsiveWidgetAccessibilityProfile"
              style={{ border: "none" }}
            >
              <ProfileRow
                handle={() => SeizureSafeProfile(PARAMETER_EVENT.TOGGLE)}
                classNameResp={"profile-safe-seizure"}
                arialabel="seizure safe profile"
                arialabelaria="Seizure Safe Profile"
                arialabelpara="Clear flashes & reduces color"
                name="Seizure Safe Profile"
                para="Clear flashes & reduces color"
              />
              <ProfileRow
                handle={() => visionImpairedProfile(PARAMETER_EVENT.TOGGLE)}
                classNameResp={"respBoxNone profile-impaired-vision"}
                arialabel="vision impaired profile"
                arialabelaria="Vision Impaired Profile"
                arialabelpara="Enhances website's visuals"
                name="Vision Impaired Profile"
                para="Enhances website's visuals"
              />
              <ProfileRow
                handle={() => adhdFriendlyProfile(PARAMETER_EVENT.TOGGLE)}
                classNameResp="respBoxNone profile-friendly-AdHd"
                arialabelaria="ADHD Friendly Profile"
                arialabelpara="More focus & fewer distractions"
                arialabel="ADHD Friendly Profile"
                name="ADHD Friendly Profile"
                para="More focus & fewer distractions"
              />
              <ProfileRow
                handle={() =>
                  cognitiveDisabilityProfile(PARAMETER_EVENT.TOGGLE)
                }
                classNameResp="profile-disability-cognitive"
                arialabelaria="cognitive disability profile"
                arialabelpara="Assists with reading & focusing"
                arialabel="Cognitive Disability Profile"
                name="Cognitive Disability Profile"
                para="Assists with reading & focusing"
              />
              <ProfileRow
                handle={() => blindUserScreenReader(PARAMETER_EVENT.TOGGLE)}
                classNameResp="reader-screen-user-blind"
                arialabelaria="Blind Users (Screen Reader)"
                arialabelpara="Optimize website for screen-readers"
                arialabel="blind users (screen reader)"
                name="Blind Users (Screen Reader)"
                para="Optimize website for screen-readers"
              />
              <ProfileRow
                handle={() => overSizeWidget(PARAMETER_EVENT.TOGGLE)}
                classNameResp="size-widget"
                arialabelaria="Oversized Widget"
                arialabelpara="Widget Extra Large Size"
                arialabel="Oversized Widget"
                name="Oversized Widget"
                para="Widget Extra Large Size"
              />
              <ProfileRow
                handle={() => dyslexicFont(PARAMETER_EVENT.TOGGLE)}
                classNameResp="font-dyslexic"
                arialabelaria="Dyslexia Friendly Font"
                arialabelpara="Accessibility Dyslexia Friendly"
                arialabel="Dyslexia Friendly Font"
                name="Dyslexia Friendly Font"
                para="Accessibility Dyslexia Friendly"
              />
              <ProfileRow
                handle={() => keyboardNavigation(PARAMETER_EVENT.TOGGLE)}
                classNameResp="keyboard-navigation respBoxNone"
                arialabelaria="Keyboard Navigations"
                arialabelpara="Accessibility Dyslexia Friendly"
                arialabel="Keyboard Navigations"
                name="Keyboard Navigations"
                para="Use website with the keyboard"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="WidgetPopUpCardContainer">
        <div className="WidgetpopupContent ">
          <h2
            className="WidgetPopupHeading"
            role="region"
            aria-label="Content Ajustments"
          >
            Content Ajustments
          </h2>
          <div className="WidgetAjustmentBoxContainer">
            <div className="WidgetContentAjustmentBoxContainerContent">
              <div className="WidgetContentAjustmentBoxRow ">
                <WidgetBoxSmall
                  arialabel="text align left"
                  id="textAlignLeft"
                  onClick={() => textAlignLeft(PARAMETER_EVENT.TOGGLE)}
                >
                  <LeftIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="text align left "
                  >
                    Text Align
                    <span>Left</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  arialabel="text align center"
                  id="textAlignCenter"
                  onClick={() => textAlignCenter(PARAMETER_EVENT.TOGGLE)}
                >
                  <CenterIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="text align center "
                  >
                    Text Align
                    <span>Center</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  arialabel="text align right"
                  id="textAlignRight"
                  onClick={() => textAlignRight(PARAMETER_EVENT.TOGGLE)}
                >
                  <RightIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="text align right "
                  >
                    Text Align
                    <span>Right</span>
                  </p>
                </WidgetBoxSmall>
              </div>
              <div className="WidgetContentAjustmentBoxRow ">
                <WidgetBoxSmall
                  arialabel="readable font"
                  onClick={() => readableFont(PARAMETER_EVENT.TOGGLE)}
                  id="readableFont"
                >
                  <FontIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="Readable font"
                  >
                    Readable
                    <span>Font</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetContentAdjustmentBoxLarge
                  arialabel="Content Scaling"
                  className="respBoxNone"
                  title="Content Scaling"
                  increaseButton="content scaling increase button"
                  decreaseButton="content scaling decrease button"
                  onClickMinus={() => contentScaling("minus")}
                  onClickPlus={() => contentScaling("plus")}
                  Default={
                    zoom === 1
                      ? "Default"
                      : `${zoom > 1 ? "+" : ""}${Math.round(
                          (zoom - 1) * 1000
                        )}%`
                  }
                >
                  <ZoomOutSmIcon />
                </WidgetContentAdjustmentBoxLarge>
              </div>
              <div className="WidgetContentAjustmentBoxRow ">
                <WidgetBoxSmall
                  arialabel="text magnifier"
                  id={"textMagnifier"}
                  onClick={() => textMagnifier(PARAMETER_EVENT.TOGGLE)}
                >
                  <ZoomIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="text magnifier"
                  >
                    Text
                    <span>Magnifier</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetContentAdjustmentBoxLarge
                  arialabel="adjust font sizing"
                  title="Adjust Font Sizing"
                  increaseButton="font size increase button"
                  decreaseButton="font size decrease button"
                  onClickMinus={() => handleFontSize("minus")}
                  onClickPlus={() => handleFontSize("plus")}
                  Default={
                    fontsize === 0
                      ? "Default"
                      : `${fontsize > 0 ? "+" : ""}${(fontsize - 0) * 10}%`
                  }
                >
                  <ZoomOutSmIcon />
                </WidgetContentAdjustmentBoxLarge>
              </div>
              <div className="WidgetContentAjustmentBoxRow ">
                <WidgetBoxSmall
                  arialabel="highLight links"
                  id="highLightLinks"
                  onClick={() => HighlightLinks(PARAMETER_EVENT.TOGGLE)}
                >
                  <MarkerIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="Highlight links"
                  >
                    Highlight
                    <span>Links</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetContentAdjustmentBoxLarge
                  arialabel="adjust line height"
                  title="Adjust Line Height"
                  increaseButton="line height increase button"
                  decreaseButton="line height decrease button"
                  onClickMinus={() => handleLineHeight("minus")}
                  onClickPlus={() => handleLineHeight("plus")}
                  Default={
                    lineHeight === 1.5
                      ? "Default"
                      : `${lineHeight > 1.5 ? "+" : ""}${Math.round(
                          (lineHeight - 1.5) * 100
                        )}%`
                  }
                >
                  <ZoomOutSmIcon />
                </WidgetContentAdjustmentBoxLarge>
              </div>
              <div className="WidgetContentAjustmentBoxRow ">
                <WidgetBoxSmall
                  arialabel="highLight title"
                  id="highLightTiles"
                  onClick={() => highLightTile(PARAMETER_EVENT.TOGGLE)}
                >
                  <PaperIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="Highlight Titles"
                  >
                    Highlight
                    <span>Titles</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetContentAdjustmentBoxLarge
                  arialabel="adjust letter spacing"
                  title="Adjust Letter Spacing"
                  increaseButton="letter spacing increase button"
                  decreaseButton="letter spacing decrease button"
                  onClickMinus={() => handleLetterSpacing("minus")}
                  onClickPlus={() => handleLetterSpacing("plus")}
                  Default={
                    letterSpacing === 1
                      ? "Default"
                      : `${letterSpacing > 1 ? "+" : ""}${Math.round(
                          (letterSpacing - 1) * 10
                        )}%`
                  }
                >
                  <ZoomOutSmIcon />
                </WidgetContentAdjustmentBoxLarge>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="WidgetPopUpCardContainer">
        <div className="WidgetpopupContent">
          <h2
            className="WidgetPopupHeading"
            role="region"
            aria-label="Color Ajustments"
          >
            Color Ajustments
          </h2>
          <div className="WidgetAjustmentBoxContainer">
            <div className="WidgetColorAjustmentBoxContainerContent">
              <div className="WidgetColorAjustmentBoxRow">
                <WidgetBoxSmall
                  onClick={() => lowSaturation(PARAMETER_EVENT.TOGGLE)}
                  id={"saturationLow"}
                  arialabel="low saturation"
                >
                  <DropOfLiquidIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="low saturation"
                  >
                    Low
                    <span>Saturation</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  onClick={() => highSaturation(PARAMETER_EVENT.TOGGLE)}
                  arialabel="high saturation"
                  id={"saturationHight"}
                >
                  <InkIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="high saturation"
                  >
                    High
                    <span>Saturation</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  onClick={() => monoChromeSaturation(PARAMETER_EVENT.TOGGLE)}
                  id={"saturationMonoChrome"}
                  arialabel="monochrome saturation"
                >
                  <DropSilhouetteIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="monochrome saturation"
                  >
                    Monochrome
                    <span>Saturation</span>
                  </p>
                </WidgetBoxSmall>
              </div>
              <div className="WidgetColorAjustmentBoxRow">
                <WidgetBoxSmall
                  onClick={() => highContrast(PARAMETER_EVENT.TOGGLE)}
                  id={"highContrast"}
                  arialabel="high contrast"
                >
                  <DarkModeIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="high contrast"
                  >
                    High
                    <span>Contrast</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetColorAdjustmentBoxLarge
                  arialabel="Adjust Text Colors"
                  arialabelLabel="Adjust text Colors"
                  ariaHandleName="text color"
                  title="Adjust Text Colors"
                  setClass="rcpTextColorClass"
                  handle={handleTextColor}
                />
              </div>
              <div className="WidgetColorAjustmentBoxRow">
                <WidgetBoxSmall
                  onClick={() => lightContrast(PARAMETER_EVENT.TOGGLE)}
                  id={"lightContrast"}
                  arialabel="light contrast"
                >
                  <LightModeIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="light contrast"
                  >
                    Light
                    <span>Contrast</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetColorAdjustmentBoxLarge
                  arialabel="Adjust Title Colors"
                  arialabelLabel="Adjust title Colors"
                  ariaHandleName="title color"
                  title="Adjust Title Colors"
                  setClass="rcpTitleColorClass"
                  handle={handletitleColor}
                />
              </div>
              <div className="WidgetColorAjustmentBoxRow">
                <WidgetBoxSmall
                  onClick={() => darkContrast(PARAMETER_EVENT.TOGGLE)}
                  id="darkContrast"
                  arialabel="dark contrast"
                >
                  <RightModeIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="Dark Contrast"
                  >
                    Dark
                    <span>Contrast</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetColorAdjustmentBoxLarge
                  arialabel="Adjust background Colors"
                  arialabelLabel="Adjust Background Colors"
                  ariaHandleName="Background color"
                  title="Adjust Background Colors"
                  setClass="rcpBgColorClass"
                  handle={handleBackgrondColor}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="WidgetPopUpCardContainer">
        <div className="WidgetpopupContent">
          <h2
            className="WidgetPopupHeading"
            role="region"
            aria-label="Orientation Ajustments"
          >
            Orientation Ajustments
          </h2>
          <div className="WidgetAjustmentBoxContainer">
            <div className="WidgetOrientationAjustmentBoxContainerContent">
              <div className="WidgetOrientationAjustmentBoxRow">
                <WidgetBoxSmall
                  arialabel="mute sound"
                  onClick={() => muteSound(PARAMETER_EVENT.TOGGLE)}
                  id="muteSound"
                >
                  <MuteIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="mute sounds"
                  >
                    Mute
                    <span>Sounds</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  arialabel="hide images"
                  onClick={() => hideImages(PARAMETER_EVENT.TOGGLE)}
                  id="hideImage"
                >
                  <ImageIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="hide images"
                  >
                    Hide
                    <span>Images</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  onClick={() => readMode(PARAMETER_EVENT.TOGGLE)}
                  className="respBoxNone"
                  arialabel="read mode"
                  id="readMode"
                >
                  <ReadingModeIcon />
                  <p className="flexColum" role="region" aria-label="read mode">
                    Read
                    <span>Mode</span>
                  </p>
                </WidgetBoxSmall>
              </div>
              <div className="WidgetOrientationAjustmentBoxRow">
                <WidgetBoxSmall
                  arialabel="stop animation"
                  onClick={() => animationsStop(PARAMETER_EVENT.TOGGLE)}
                  id="animationsStop"
                >
                  <StopAnimationIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="stop animations"
                  >
                    Stop
                    <span>Animations</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  className="respBoxNone"
                  arialabel="reading mask"
                  onClick={() => readingMask(PARAMETER_EVENT.TOGGLE)}
                  id="readingMask"
                >
                  <ReadingMaskIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="reading mask"
                  >
                    Reading
                    <span>Mask</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  arialabel="reading guide"
                  onClick={() => readingGuide(PARAMETER_EVENT.TOGGLE)}
                  id="readingGuide"
                  className="respBoxNone"
                >
                  <ReadingGuideIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="reading guide"
                  >
                    Reading
                    <span>Guide</span>
                  </p>
                </WidgetBoxSmall>
              </div>
              <div className="WidgetOrientationAjustmentBoxRow">
                <WidgetBoxSmall
                  className="respBoxNone"
                  arialabel="highLight focus"
                  onClick={() => highLightFocus(PARAMETER_EVENT.TOGGLE)}
                  id="highLightFocus"
                >
                  <HighlightFocusIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="highLight focus"
                  >
                    Highlight
                    <span>Focus</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  arialabel="black big curser"
                  className="respBoxNone"
                  onClick={() => cursorBlack(PARAMETER_EVENT.TOGGLE)}
                  id="blackCursor"
                >
                  <BlackCurserIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="big black curser"
                  >
                    Big Black
                    <span>Curser</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetBoxSmall
                  className="respBoxNone"
                  arialabel="white big curser"
                  onClick={() => cursorWhite(PARAMETER_EVENT.TOGGLE)}
                  id="curserWhite"
                >
                  <WhiteCurserIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="big white curser"
                  >
                    Big White
                    <span>Curser</span>
                  </p>
                </WidgetBoxSmall>
              </div>
              <div className="WidgetOrientationAjustmentBoxRow">
                <WidgetBoxSmall
                  arialabel="highLight hover"
                  onClick={() => highlightHover(PARAMETER_EVENT.TOGGLE)}
                  id="hightlightHover"
                  className="respBoxNone"
                >
                  <HighlightHoverIcon />
                  <p
                    className="flexColum"
                    role="region"
                    aria-label="highLight hover"
                  >
                    Highlight
                    <span>Hover</span>
                  </p>
                </WidgetBoxSmall>
                <WidgetOrientationAdjustmentBoxLarge
                  handle={(e) => {
                    UseFulLinks(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <WidgetFooter />
    </section>
  );
};

export default WidgetPopup;
